import { Component, ElementRef, EventEmitter, Output, ViewChild, OnInit, Input } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, ButtonLoader, MessageService } from '../../../../core';
import { Cliente } from '../../../pessoa/cliente/cliente';
import { ClienteCrudHttpService } from '../../../pessoa/cliente/services';
import { TypeaheadClienteComponent } from '../../../pessoa/cliente/typeahead';
import { ClienteCarteiraCongelar } from '../cliente-carteira-congelar';
import { ClienteCarteiraCongelado } from '../cliente-carteira-congelado';
import { ClienteCarteiraCongelarHttpService } from '../services';
import { RepresentanteCrudHttpService } from '../../../pessoa/representante/services';
import { MotivoPerdaVendaSelectComponent } from '../../../motivo-perda-venda/select';
import { ClienteNomePipe } from '../../../pessoa/cliente/pipes';

@Component({
    selector: 'sgt-cliente-carteira-congelar-modal',
    templateUrl: './cliente-carteira-congelar-modal.component.html',
    styleUrls: ['./cliente-carteira-congelar-modal.component.less']
})
export class ClienteCarteiraCongelarModalComponent implements OnInit {
    entity: ClienteCarteiraCongelar;
    canEditCliente: boolean;
    elModal: any;

    @Input() isRepresentante: boolean;
    @Output() afterCancel = new EventEmitter<any>();
    @Output() afterCongelar = new EventEmitter<ClienteCarteiraCongelado>();

    @ViewChild('form') form: NgForm;
    @ViewChild('typeaeadCliente') typeaeadCliente: TypeaheadClienteComponent;
    @ViewChild('motivoCongelamentoSelect') motivoCongelamentoSelect: MotivoPerdaVendaSelectComponent;

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private clienteCrudHttpService: ClienteCrudHttpService,
                private representanteCrudHttpService: RepresentanteCrudHttpService,
                private clienteCarteiraCongelarHttpService: ClienteCarteiraCongelarHttpService,
                private clienteNomePipe: ClienteNomePipe) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                if (this.canEditCliente) {
                    this.typeaeadCliente?.setFocus();
                } else {
                    this.motivoCongelamentoSelect?.setFocus();
                }

                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    /** Insere um novo congelamento de cliente */
    insert(idCliente: number) {
        this.elModal.modal({keyboard: false, backdrop: 'static'});

        this.entity = new ClienteCarteiraCongelar();
        // Se informado o cliente para ser congelado então carregamos o cliente e não permitimos editar
        if (idCliente) {
            this.canEditCliente = false;
            this.loadCliente(idCliente);
        } else { // Se não, permite editar o cliente para poder selecioná-lo
            this.canEditCliente = true;
        }
    }

    /** Reseta o form e fecha o modal */
    private close() {
        this.elModal.modal('hide');
        this.entity = null;
    }

    /** Cancela o congelamento do cliente */
    cancel() {
        this.close();
        this.afterCancel.emit();
    }

    /** Ao selecionar o cliente */
    onSelectCliente(cliente: Cliente) {
        if (cliente) {
            this.entity.idCliente = cliente.id;
            this.findRepresentanteCliente(cliente.idRepresentante);
        } else {
            this.onClearCliente();
        }
    }

    /** Ao remover o cliente */
    onClearCliente() {
        this.entity.idCliente = null;
        this.entity.representante = null;
    }

    /** Carrega o cliente do congelamento */
    private loadCliente(idCliente: number) {
        this.clienteCrudHttpService.load(idCliente)
            .subscribe(
                cliente => {
                    this.entity.cliente = cliente;
                    this.onSelectCliente(this.entity.cliente);
                },
                (() => {
                    this.entity.idCliente = null;
                    this.entity.cliente = null;
                })
            );
    }

    /** Pesquisa o representante do cliente congelado */
    private findRepresentanteCliente(idRepresentante: number) {
        this.representanteCrudHttpService.find(idRepresentante)
            .subscribe(
                representante => this.entity.representante = representante,
                () => this.entity.representante = null
            );
    }

    /** Realiza o congelamento do cliente */
    congelar() {
        if (this.form.valid) {
            const btn = new ButtonLoader('#btnClienteCongelarModal');
            btn.loading('Congelando');
            const nomeClinete = this.clienteNomePipe.transform(this.entity.cliente?.pessoa?.nome, this.entity.cliente?.pessoa?.nomeFantasia, this.entity.cliente?.pessoa?.codigoIntegracaoErp) ?? '';

            this.clienteCarteiraCongelarHttpService.congelar(this.entity)
                .subscribe(
                    clienteCongelado => {
                        btn.reset();
                        this.messageService.success('', `Cliente ${nomeClinete} congelado com sucesso`);
                        this.afterCongelar.emit(clienteCongelado);
                        this.close();
                    },
                    (error: ApiError) => {
                        btn.reset();
                        this.messageService.error(error.message, `Erro ao congelar o cliente ${nomeClinete}`, error);
                    }
                )
        } else {
            this.messageService.info('Para congelar o cliente é necessário informar corretamente todos os campos destacados em vermelho', 'Informação');
        }
    }
}
